var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-container"},[_c('div',{staticClass:"content"},[_c('comp-room',{attrs:{"type":"invite","sdkAppId":Number(_vm.sdkAppId),"inviteUserSig":_vm.userSig,"userId":_vm.userId,"roomId":Number(_vm.roomId)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }